export const STATUS_NOT_FOUND = 404;

export const handleAxiosException = (exception) => {
  const response = exception.response;

  if (!response) {
    throw exception;
  }

  switch (response.status) {
    case 404:
      return STATUS_NOT_FOUND;
    default:
      console.warn('not implemented');
      throw exception;
  }
};
